import {Component, OnDestroy, OnInit} from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import {Http, Response} from '@angular/http';
import {Events, IonicPage, LoadingController, NavController, ToastController, MenuController} from 'ionic-angular';

import {HelpPage} from '../help/help';
import {ProofTermsPage} from '../proof-terms/proof-terms';
import {NewSubscriptionStep1Page} from '../new-subscription-step1/new-subscription-step1';
import {NewSubscriptionStep4Page} from '../new-subscription-step4/new-subscription-step4';
import {QuizzAboutPage} from '../quizz-about/quizz-about';

import {AlertProvider} from '../../providers/alert/alert';
import {NetworkMonitorProvider} from '../../providers/network-monitor/network-monitor';
import {AuthProvider} from '../../providers/auth/auth';
import {UploadingProvider} from '../../providers/uploading/uploading';
import {ProofServerProvider} from '../../providers/proof-server/proof-server';
import {ProofProvider} from '../../providers/proof/proof';
import {TitleProvider} from '../../providers/title/title';
import {SystemProvider} from '../../providers/system/system';
import {EventEmitterProvider} from '../../providers/event-emitter/event-emitter';
import {RegistrationProvider} from '../../providers/registration/registration';
import {QuizzServerProvider} from '../../providers/quizz-server/quizz-server';

import {SendingStatus} from '../../models/sendingstatus';

import * as Config from '../../app/app.config';

import {WindowProtectorProvider} from '../../providers/window-protector/window-protector';

import {FullscreenProvider} from '../../providers/fullscreen/fullscreen';
import {ScreenDetailsProvider} from '../../providers/screen-details/screen-details';
import { forEach } from 'lodash';

/**
 * Generated class for the ProofListPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-proof-list',
  templateUrl: 'proof-list.html',
})
export class ProofListPage {

  hasSubscription: boolean;
  loading: boolean;
  private user: any;
  public userFilesGet: any[];
  private items: any = [];
  private categories: any[] = [];
  private subcategories: any[] = [];
  sending: any;
  private doUpdateSubscription: any;

  private canContractQuizz: boolean = false;
  private canContractQuizzSubscription: any;

  public hasProofThatRequiresAssistance: boolean = false;

  public contractEndDate: string = '';
  public remaining: any = {};
  private interval: any;

  constructor(
    private http: Http,
    private navCtrl: NavController,
    private alertProvider: AlertProvider,
    private networkMonitor: NetworkMonitorProvider,
    private uploadingprovider: UploadingProvider,
    private authProvider: AuthProvider,
    private loadingCtrl: LoadingController,
    private toastCtrl: ToastController,
    private proofServerProvider: ProofServerProvider,
    private proofProvider: ProofProvider,
    private titleProvider: TitleProvider,
    private systemProvider: SystemProvider,
    private events: Events,
    private eventEmitterProvider: EventEmitterProvider,
    private registrationProvider: RegistrationProvider,
    private quizzServerProvider: QuizzServerProvider,
    private windowProtectorProvider: WindowProtectorProvider,
    private fullScreenProvider: FullscreenProvider,
    private screenDetailsProvider: ScreenDetailsProvider,
    private fb: FormBuilder,
    private menu: MenuController,
  ) {

    this.continuousForm = this.fb.group({
      upload_file: [null],
      document_date: [''],
      document_category_id: [null],
      document_subcategory_id: [null],
      workload_hours: [null]
    });

    this.loading = false;
    this.user = this.authProvider.getUser();
    this.hasSubscription = this.authProvider.hasSubscription();

    this.networkMonitor.setCallback(null);
    this.networkMonitor.stop();

    this.prepareSendingStatus();

    // FIX: 2019-01-02 20:53 Francisco - Force update of proofs, because not a proof can be created after subscription released
    this.doUpdate(true);

    let that = this;
    this.doUpdateSubscription = this.eventEmitterProvider.get('do_update').subscribe(() => {
      that.doUpdate(true);
    });

    if (Config.quizzEnabled) {
      this.canContractQuizzSubscription = this.eventEmitterProvider.get('can_contract_quizz').subscribe((canContractQuizz: boolean) => {
        if ((canContractQuizz !== null) && (canContractQuizz !== undefined)) {
          that.canContractQuizz = canContractQuizz;
        } else {
          that.canContractQuizz = true;
        }
      });

      if (this.quizzServerProvider.getCanContractQuizz()) {
        this.canContractQuizz = true;
      }
    }
  }

  ngOnInit() {
    this.checkFiles();
    this.loadCategories();
  }

  startCountdown() {
    const baseDate = new Date(this.contractEndDate);
    baseDate.setHours(23, 59, 59, 999);

    const end = new Date(this.contractEndDate).getTime();

    this.interval = setInterval(() => {
      const now = new Date().getTime();
      const diff = end - now;

      if (diff <= 0) {
        this.remaining = {
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0
        };
        clearInterval(this.interval);
        return;
      }

      this.remaining = {
        days: Math.floor(diff / (1000 * 60 * 60 * 24)),
        hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((diff / (1000 * 60)) % 60),
        seconds: Math.floor((diff / 1000) % 60),
      };

      const total = end - now;
      const percent = total / (1000 * 60 * 60 * 24 * 7); // baseado em 7 dias (ajustável)

      let colorClass = 'timer-green';
      if (percent < 0.50) colorClass = 'timer-yellow';
      if (percent < 0.20) colorClass = 'timer-red';

      this.remaining.colorClass = colorClass;

    }, 1000);
  }

  ngOnDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ProofListPage');
  }

  ionViewWillLeave() {
    this.doUpdateSubscription.unsubscribe();

    if (Config.quizzEnabled) {
      this.canContractQuizzSubscription.unsubscribe();
    }
  }

  doUpdate(force: boolean) {
    console.log('ProofListPage.doUpdate');

    this.authProvider.getProofRequiresAssistance().subscribe((result: any): void => {
      // console.log('ProofListPage.doUpdate.getProofRequiresAssistance', result);

      // if (result) {
      //   this.hasProofThatRequiresAssistance = true;
      // } else {
        this.hasProofThatRequiresAssistance = false;
        this.doUpdateIfNoOneRequiresAssistance(force);
      // }
    });
  }

  doPQC(proofId: number) {
    this.navCtrl.push(NewSubscriptionStep4Page, {

      proofId: proofId,
      animation: 'ios-transition'
    });
  }

  private doUpdateIfNoOneRequiresAssistance(force: boolean): void {
    console.log('ProofListPage.doUpdateIfNoOneRequiresAssistance');
    let that = this;

    // if (this.isAbleToContinue()) {

    if ((!this.sending.active) && (!this.loading)) {
      this.loading = true;

      this.prepareSendingStatus();

      let loader = this.loadingCtrl.create({
        content: 'Verificando...',
      });
      loader.present();

      this.items = [];
      if (this.authProvider.hasProofInOtherAccessKind()) {
        this.items.push({
          kind: 'hasProofInOtherAccessKind'
        });
      }

      this.authProvider.getProof(force).subscribe(data => {
       console.log('ProofListPage.doUpdate.Proof', data);

        if(data && data.certificationValidityEnd != ''){
          this.contractEndDate = data.certificationValidityEnd;
          this.startCountdown();
        }

        let proofPendingPayment = false;
        let headers = that.authProvider.createApplicationHeadersWithBearer();
        that.http.get(Config.baseUrl + '/subscriptions', {headers: headers}).map((res: Response) => res.json()).subscribe((subscriptions) => {

          for (var x = 0; x < subscriptions.length; x++) {
            if (subscriptions[x].paymentStatus === 'OPN') {
              proofPendingPayment = true;
              this.hasSubscription = true;

              that.items.push({
                kind: 'proofPendingPayment',
                proof: subscriptions[x].proof
              });

            }
          }
        });

        if (!data) {
          that.items.push({
            kind: 'unchecked',
            description: 'Não há prova disponível',
            value: -1
          });

          that.loading = false;
          loader.dismiss();
        } else {
          that.proofProvider.isFinished(data).subscribe((finished: boolean) => {
            if (finished) {

              that.alertProvider.doWaitingHide();

              // DONE: It is now automatically
              that.sendProofAnswered(data.id);
            } else {

              let proofPendingPayment = false;
              let headers = that.authProvider.createApplicationHeadersWithBearer();
              that.http.get(Config.baseUrl + '/subscriptions', {headers: headers})
                .map((res: Response) => res.json())
                .subscribe((subscriptions) => {

                  for (var x = 0; x < subscriptions.length; x++) {
                    if ( /* subscriptions[x].proof.id === data.proofId && */ subscriptions[x].paymentStatus === 'OPN') {
                      proofPendingPayment = true;
                      console.log('proofPendingPayment: true');
                    }
                  }

                  if (!proofPendingPayment) {
                    //TO DO VERIFICAR STATUS DE BLOQUEIO 'openProof'
                    that.items.push({
                      kind: 'do_proof',
                      proof: data
                    });
                  } else {
                    //TO DO VERIFICAR STATUS DE BLOQUEIO 'proofPendingPayment'
                    that.items.push({
                      kind: 'proofPendingPayment',
                      proof: data
                    });
                  }
              });
            }

            that.loading = false;
            loader.dismiss();
          }, (error: any) => {
            console.log(error);
            that.loading = false;
            loader.dismiss();
          });
        }
      }, (error: any) => {
        loader.dismiss();
        console.log('Não foi possível obter a prova.', error);

        let toast = this.toastCtrl.create({
          message: 'Não foi possível obter a prova.',
          duration: 3000,
          position: 'bottom'
        });
        toast.present();

        this.loading = false;
      });
    } else {
      let toast = this.toastCtrl.create({
        message: 'Não pode atualizar no momento. Aguarde um pouco e tente novamente.',
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }

  }

  async goToProofTermsPage(id: number) {
    if(this.userFilesGet.length == 0){
      this.alertProvider.doAlert('É necessário anexar o documento para auditoria.', 'Atenção');
      return;      
    }

    let that = this;
    this.loading = true;

    let loader = this.loadingCtrl.create({
      content: 'Obtendo detalhes...',
    });
    loader.present();

    const screenDetails = await this.screenDetailsProvider.getQuantity();
    console.log(screenDetails);
    localStorage.setItem('exams.screens', JSON.stringify(screenDetails));

    // this.fullScreenProvider.requestFullscreen().then((): void => {
    //   // Do nothing.
    // });

    this.proofServerProvider.fetch(id).subscribe(proof => {
      that.proofProvider.initiate(proof);
      that.loading = false;
      loader.dismiss();

      // that.events.subscribe('doProofUpdate', (paramsVar) => {
      //   console.log('ProofListPage.goToProofTermsPage.doUpdate', paramsVar);
      //   that.doUpdate(false);

      //   that.events.unsubscribe('doProofUpdate');
      // });
      that.events.subscribe('doProofUpdate', () => {
        console.log('ProofListPage.goToProofTermsPage.doUpdate');
        that.doUpdate(false);

        that.events.unsubscribe('doProofUpdate');
      });

      this.windowProtectorProvider.start();

      that.navCtrl.push(ProofTermsPage);
    }, (error: any) => {
      loader.dismiss();
      console.log('Não foi possível obter os detalhes da prova.', error);

      let toast = that.toastCtrl.create({
        message: 'Não foi possível obter os detalhes da prova.',
        duration: 3000,
        position: 'bottom'
      });
      toast.present();

      that.loading = false;
    });
  }

  sendProofAnswered(id: number) {
    let that = this;
    this.loading = true;

    this.alertProvider.doWaiting('Enviando...');
    this.prepareSendingStatus();

    this.proofServerProvider.send(id, this.sending,

      // onFinish
      (sendingStatus: any) => {
        that.loading = false;

        that.alertProvider.doWaitingHide();

        if (sendingStatus.done) {
          let message = 'Sua prova foi concluída com sucesso. Favor aguardar a divulgação do resultado.';

          that.alertProvider.doAlert(message, 'Aviso', () => {
            // that.systemProvider.close();
            // that.doUpdate(true);
            // Global
            that.eventEmitterProvider.get('do_update').emit();
          });
        }
      });
  }

  private prepareSendingStatus() {
    this.sending = new SendingStatus();
  }

  askHelp() {
    this.navCtrl.push(HelpPage);
  }

  goToNewSubscription() {
    // if (this.isAbleToContinue()) {
    this.navCtrl.push(NewSubscriptionStep1Page);
    // }
  }

  // private isAbleToContinue() {
  //   let ableToContinue = true;
  //
  //   // Verify if this registration is complete
  //   if (!this.registrationProvider.isComplete()) {
  //     ableToContinue = false;
  //
  //     this.alertProvider.doAlert('Você precisa atualizar seu cadastro para poder continuar.', null, () => {
  //       this.navCtrl.setRoot(UpdateRegistrationPage);
  //       this.navCtrl.popToRoot({
  //         animation: 'ios-transition'
  //       });
  //     });
  //   }
  //
  //   return ableToContinue;
  // }

  goToQuizzAboutPage() {
    this.navCtrl.setRoot(QuizzAboutPage);
    this.navCtrl.popToRoot({
      animation: 'ios-transition'
    });
  }


  continuousForm: FormGroup;
  selectedFile: any = null;

  loadCategories() {
    this.titleProvider.getCategories().subscribe(
      res => {
        if (res) {
          this.categories = res;
          // console.log('Categorias carregadas:', this.categories);
        }
      },
      err => {
        console.error('Erro ao carregar categorias', err);
      }
    );
  }

  onCategoryChange(categoryId: number) {
    this.subcategories = []; // limpa antes
    this.continuousForm.patchValue({ document_subcategory_id: null });

    this.titleProvider.getSubcategories(categoryId).subscribe(
      res => {
        if (res) {
          this.subcategories = res;
          console.log('Subcategorias carregadas:', this.subcategories);
        }
      },
      err => {
        console.error('Erro ao carregar subcategorias', err);
      }
    );
  }

  getSubcategoryName(id: number): string {
    if (!this.subcategories || this.subcategories.length === 0) {
      return '';
    }

    const sub = this.subcategories.find(s => s.id === id);
    return sub ? sub.name : '';
  }

  getCategoryName(id: number): string {
    const cat = this.categories.find(c => c.id === id);
    return cat ? cat.name : '';
  }

  handleFileInput(event: any) {
    this.selectedFile = event.target.files[0];
    this.continuousForm.patchValue({ upload_file: this.selectedFile });
  }

  saveContinuousFile() {
    const form = this.continuousForm.value;

    if (!this.networkMonitor.isOnline()) {
      this.alertProvider.doAlert('É necessário estar conectado na Internet.', 'Atenção');
      return;
    }

    if (!this.selectedFile) {
      this.alertProvider.doAlert('É necessário enviar um arquivo.', 'Atenção');
      return;
    }

    if (!form.document_date) {
      this.alertProvider.doAlert('Informe a data do documento.', 'Atenção');
      return;
    }

    if (!form.document_category_id) {
      this.alertProvider.doAlert('Selecione uma categoria.', 'Atenção');
      return;
    }

    if (!form.document_subcategory_id) {
      this.alertProvider.doAlert('Selecione uma subcategoria.', 'Atenção');
      return;
    }

    if (!form.workload_hours || form.workload_hours <= 0) {
      this.alertProvider.doAlert('Informe a carga horária corretamente.', 'Atenção');
      return;
    }

    this.alertProvider.doConfirm('Deseja salvar este documento?', () => {

      const loader = this.loadingCtrl.create({
        content: 'Enviando documento...',
      });
      loader.present();

      const formData = new FormData();

      formData.append('titleId', '18');
      formData.append('file', this.selectedFile);
      formData.append('document_date', form.document_date);
      formData.append('document_category_id', form.document_category_id);
      formData.append('document_subcategory_id', form.document_subcategory_id);
      formData.append('workload_hours', form.workload_hours);

      const userId = this.user.id;

      this.uploadingprovider.uploadFormTitleData(formData, userId).subscribe(
        (response: any) => {
          loader.dismiss();
          if (response && response.updated) {

            this.alertProvider.doAlert('Documento salvo com sucesso!', 'Sucesso');

            // limpa formulário
            this.continuousForm.reset();
            this.selectedFile = null;
            this.checkFiles();

          } else {
            this.alertProvider.doAlert('Erro ao salvar documento.', 'Erro');
          }
        },

        (error) => {
          loader.dismiss();
          this.alertProvider.doAlert('Falha na comunicação com o servidor.', 'Erro');
        }
      );

    });
  }

  removeFile(fileId) {
    this.uploadingprovider.removeTitleFile(fileId).subscribe((response: any) => {
      if ((response) && (response.updated)) {
        //loader.dismiss();
        this.checkFiles();
        console.log("removeTitleFile", response);
      }
    });
  }

  checkFiles() {
    let loader = this.loadingCtrl.create({
      content: 'Obtendo Arquivos...',
      // duration: 3000
    });
    loader.present();

    this.uploadingprovider.listTitlesFiles(this.user.id).subscribe((response: any) => {
      if (response) {
        this.userFilesGet = response.filter(item =>
          item.documentCategoryId &&
          item.documentSubcategoryId
        );
        // console.log('listTitlesFiles response ->', response);
        loader.dismiss();
      } 
    }, (error: any) => {
      console.log(error);
      loader.dismiss();
      this.alertProvider.doAlert('Houve problemas ao tentar verificar se existem arquivos em anexo.', 'Atenção');
    });
  }

  doFinishProof(){
    this.menu.enable(true);
    this.menu.swipeEnable(true);

    this.proofProvider.setFinished();
    this.alertProvider.doWaiting('Processando...');    

    // TODO: Verify if its using Wifi mode and warn if not
    // DONE: Bug when #popTo direct to ProofListPage
    this.navCtrl.popTo(this.navCtrl.getByIndex(0)).then(() => {
      this.events.publish('doProofUpdate');
    });    
  }
}



// WEBPACK FOOTER //
// ./src/pages/proof-list/proof-list.ts